import { callApi } from 'loankeeper-common/api'

export const view = () =>
  callApi('udr_view', {
    params: {
      action: 'view',
    },
    method: 'post',
    body: {},
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
  })

export const viewClient = () =>
  callApi('udr_view', {
    params: {
      action: 'viewclient',
    },
    method: 'post',
    body: {},
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
  })

export const viewLoan = () =>
  callApi('udr_view', {
    params: {
      action: 'viewloan',
    },
    method: 'post',
    body: {},
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
  })

export const viewApplication = () =>
  callApi('udr_view', {
    params: {
      action: 'viewapp',
    },
    method: 'post',
    body: {},
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
  })

export const viewCollateral = () =>
  callApi('udr_view', {
    params: {
      action: 'viewcollateral',
    },
    method: 'post',
    body: {},
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
  })

export const print = (params) => {
  const { page, ...rest } = params

  return callApi('udr_view', {
    params: {
      ...rest,
      action: 'print',
    },
    method: 'post',
    body: {},
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
  })
}

export const viewcollman = () =>
  callApi('udr_view', {
    params: {
      action: 'viewcollman',
    },
    method: 'post',
    body: {},
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
  })

export const addToFavourite = (ID, hash) =>
  callApi('udr_oper', {
    params: {
      action: 'star',
      ReportID: ID,
      HashSum_ReportID_: hash,
    },
    method: 'post',
    body: {},
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
  })

export const removeFromFavourite = (ID, hash) =>
  callApi('udr_oper', {
    params: {
      action: 'unstar',
      ReportID: ID,
      HashSum_ReportID_: hash,
    },
    method: 'post',
    body: {},
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
  })

export const getSqlExcelFile = (params) => {
  const { stk, ident } = params

  return callApi('sqlreport2_view', {
    params: {
      STK: stk,
      Ident: ident,
      action: 'view',
      Format: 'xlsx',
    },
  })
}

export const generate = (params) =>
  callApi('sqlreport2', {
    params,
    method: 'post',
    body: {},
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
  })

export const reportsView = (params) =>
  callApi('sqlreport2_view', {
    params,
    method: 'post',
    body: {},
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
  })
